import { TReplaceOptions } from 'legacy/lut/library/translation/models/replaceOptions'
import { ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { FinancialTable } from 'partner360/components/financialTable'
import { ITableColumn } from 'partner360/components/financialTable'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'

import { IChartSettings } from '../../../../QBRBarChart/models'
import { QBRBarChart } from '../../../../QBRBarChart/QBRBarChart'
import { TABLE_HIERARCHY_FIELD, TABLE_KEY_FIELD } from '../../../configs'
import { TItemWithChildren } from '../../../models'

import styles from './QbrSubCharts.module.scss'

interface IProps<T> {
  item: TItemWithChildren<T>
  selectedPeriodFYear: number
  selectedPeriodFQuarters: number[]
  chartNameField: string
  currencySettings?: ReactNode
  getBarsSettings: (item: TItemWithChildren<T>) => IChartSettings[]
  getLinesSettings: (item: T) => IChartSettings[]
  columns: ITableColumn<T>[]
  title: string
  translationReplaceParams?: TReplaceOptions[]
  isSob?: boolean
}

export const QbrSubCharts = <T,>({
  item,
  selectedPeriodFYear,
  selectedPeriodFQuarters,
  chartNameField,
  currencySettings,
  getBarsSettings,
  getLinesSettings,
  columns,
  title,
  translationReplaceParams = [],
  isSob,
}: IProps<T>) => {
  return (
    <div>
      {item?.children?.map((child) => (
        <div key={child[TABLE_KEY_FIELD]}>
          <div className={styles.chartTitle}>
            <Translation
              text={title}
              replaceParams={[
                ...translationReplaceParams,
                { key: '{name}', value: child[chartNameField] },
              ]}
            />
          </div>
          <div className={styles.root__item}>
            <QBRBarChart
              selectedPeriodFYear={selectedPeriodFYear}
              selectedPeriodFQuarters={selectedPeriodFQuarters}
              chartLabelNode={currencySettings}
              barsSettings={getBarsSettings(child)}
              linesSettings={getLinesSettings(child)}
              height={400}
              isSob={isSob}
            />
            <div className={styles.tableWrapper}>
              <FinancialTable<T>
                hierarchyField={TABLE_HIERARCHY_FIELD}
                keyField={TABLE_KEY_FIELD}
                columns={columns}
                data={[child]}
                className={styles.tableStyle}
              />
            </div>
          </div>
          <QbrSubCharts
            item={child}
            selectedPeriodFYear={selectedPeriodFYear}
            selectedPeriodFQuarters={selectedPeriodFQuarters}
            currencySettings={currencySettings}
            chartNameField={chartNameField}
            getBarsSettings={getBarsSettings}
            getLinesSettings={getLinesSettings}
            columns={columns}
            title={TRANSLATION_KEYS.charts.secondChildrenLevel}
            translationReplaceParams={[
              ...translationReplaceParams,
              { key: '{parentName}', value: child[chartNameField] },
            ]}
            isSob={isSob}
          />
        </div>
      ))}
    </div>
  )
}
